module.exports = ".selected-action{text-decoration:underline;cursor:pointer}.selectable-table{padding:0 4rem 4rem}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/groups/group-create/group-create.component.scss
// module id = ./src/app/access-management/groups/group-create/group-create.component.scss
// module chunks = access-management.module